import { quizErrorMessages } from '@repo/lib/messages/quizErrorMessages';
import { useMutation } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import type { QuizStartData } from './quizService';

import { QuizService } from './quizService';

export function useStartQuiz() {
  const startQuizMutation = useMutation({
    mutationFn: (data: QuizStartData) => QuizService.startQuiz(data).then((response) => response.data),
  });

  const errorMessage = useErrorMessage(startQuizMutation.error, quizErrorMessages);

  return {
    ...startQuizMutation,
    errorMessage,
  };
}
